import { connect } from 'react-redux';
import { ENGLISH_SPEAKING_COUNTRIES } from 'apply-data';
import { ApplicationState } from '../../../../store';
import PersonalQPage6, { IProps } from './index';

import { InputFieldConfig } from '../../../../types';
import { getPageStatus } from './utils';

const mapStateToProps = (state: ApplicationState): IProps => {
  const {
    HasEnglishTest: hasEnglishTestConfig,
    EnglishTestType: englishTestTypeConfig,
    EnglishTestTypeOther: englishTestTypeOtherConfig,
    EnglishTestNotReqdReason: englishTestNotReqdReasonConfig,
    EnglishTestNotReqdReasonOther: englishTestNotReqdReasonOtherConfig,
    Qualification: qualificationConfig,
    QualificationOther: qualificationOtherConfig,
  }: {
    HasEnglishTest: InputFieldConfig;
    EnglishTestType: InputFieldConfig;
    EnglishTestTypeOther: InputFieldConfig;
    EnglishTestNotReqdReason: InputFieldConfig;
    EnglishTestNotReqdReasonOther: InputFieldConfig;
    Qualification: InputFieldConfig;
    QualificationOther: InputFieldConfig;
  } = state.student.config.Checklist.PersonalInfo.Page6;

  const {
    hasEnglishTest = hasEnglishTestConfig?.defaultValue as boolean | undefined,
    englishTestType = englishTestTypeConfig?.defaultValue as string | undefined,
    englishTestTypeOther = englishTestTypeOtherConfig?.defaultValue as string | undefined,
    englishTestNotReqdReason = englishTestNotReqdReasonConfig?.defaultValue as string | undefined,
    englishTestNotReqdReasonOther = englishTestNotReqdReasonOtherConfig?.defaultValue as string | undefined,
    qualification = qualificationConfig?.defaultValue as string | undefined,
    qualificationOther = qualificationOtherConfig?.defaultValue as string | undefined,
  } = state.student.personalInfo;

  const { complete, visible } = getPageStatus(state.student.config, {
    hasEnglishTest,
    englishTestType,
    englishTestTypeOther,
    englishTestNotReqdReasonOther,
    qualification,
    qualificationOther,
    englishTestNotReqdReason,
  });

  const {
    hasEnglishTest: hasEnglishTestVisible,
    englishTestType: englishTestTypeVisible,
    englishTestTypeOther: englishTestTypeOtherVisible,
    englishTestNotReqdReason: englishTestNotReqdReasonVisible,
    qualification: qualificationVisible,
    qualificationOther: qualificationOtherVisible,
  } = visible;

  return {
    sectionTitle: state.student.config.Checklist.PersonalInfo.shortTitle,
    complete,
    currentStep: 6,
    steps: 10,
    hasEnglishTest,
    hasEnglishTestVisible,
    hasEnglishTestConfig,
    englishTestType,
    englishTestTypeVisible,
    englishTestTypeConfig,
    englishTestTypeOther,
    englishTestTypeOtherVisible,
    englishTestTypeOtherConfig,
    englishTestNotReqdReasonConfig,
    englishTestNotReqdReason,
    englishTestNotReqdReasonOther,
    qualification,
    qualificationOther,
    englishTestNotReqdReasonVisible,
    englishTestNotReqdReasonOtherConfig,
    qualificationVisible,
    qualificationOtherVisible,
    qualificationConfig,
    qualificationOtherConfig,
    config: state.student.config,
    isPageComplete: state.student.offer.isPIPage6Complete,
    importData: state.student.importData,
    offer: state.student.offer,
    isStudentFromEnglishSpeakingCountry: state.student.summary.nationality
      ? ENGLISH_SPEAKING_COUNTRIES.some(c => c.includes(state.student.summary.nationality))
      : false,
  };
};

export default connect(mapStateToProps)(PersonalQPage6);
